const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manager dashboard component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('gradeScore', ['Application', 'Authorization', 'UserAssessments', 'AssessmentScores', 'AssessmentLib', '$q', '$translate', function (Application, Authorization, UserAssessments, AssessmentScores, AssessmentLib, $q, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      scoreId: '=',
      goBack: '&'
    },
    template: require('../../../templates/directives/assessments/grade-score.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      var contentOptions = {
        article: 'articles',
        video: 'videos',
        file: 'files',
        track: null,
        presentation: 'presentations'
      };

      self.isPdf = function(item) {
        if (!item || !item.link) {
          return false;
        }
        return item.link.slice(-3) === 'pdf';
      };

      self.isImage = function(item) {
        if (!item || !item.link) {
          return false;
        }
        return item.link.slice(-3) === 'png' || item.link.slice(-4) === 'jpeg';
      };

      self.isOther = function(item) {
        return !self.isPdf(item) && !self.isImage(item);
      };

      self.score = null;

      self.options = {
        videoSource: 'custom',
        videoDate: new Date().toString(),
        grades: {},
        settings: {},
        list: [],
        feedbackDirectory: {},
        showFeedback: false,
        activeFeedback: {},
        feedbackModel: '',
        beginFeedback: function(question, rubricId) {
          if (!question || !question.questionId) {
            return;
          }
          var qid = question.questionId;


          if (!self.options.feedbackDirectory[qid]) {
            // check if feedback in graded score
            for (var key in self.score.graded_responses) {
              if (key === qid) {
                if (self.score.graded_responses[key] && self.score.graded_responses[key].feedback) {
                  self.options.feedbackDirectory[qid] = self.score.graded_responses[key].feedback;
                }
                break;
              }
            }

            // set blank feedback
            if (!self.options.feedbackDirectory[qid]) {
              self.options.feedbackDirectory[qid] = rubricId ? {} : '';
            }
          }

          if (rubricId) {
            if (rubricId && self.options.feedbackDirectory[qid] && typeof self.options.feedbackDirectory[qid] === 'string') {
              self.options.feedbackDirectory[qid] = {};
            }

            if (!self.options.feedbackDirectory[qid][rubricId] || typeof self.options.feedbackDirectory[qid][rubricId] !== 'string') {
              self.options.feedbackDirectory[qid][rubricId] = '';
            }
            self.options.activeFeedback = {questionId: qid, rubricId: rubricId};
            self.options.feedbackModel = self.options.feedbackDirectory[qid][rubricId];
            self.options.showFeedback = true;
            return;
          }

          if (typeof self.options.feedbackDirectory[qid] !== 'string') {
            self.options.feedbackDirectory[qid] = '';
          }

          self.options.activeFeedback = {questionId: qid};
          self.options.feedbackModel = self.options.feedbackDirectory[qid];
          self.options.showFeedback = true;
        },
        cancelFeedback: function() {
          self.options.showFeedback = false;
          self.options.activeFeedback = {};
          self.options.feedbackModel = '';
        },
        saveFeedback: function() {
          if (!self.options.activeFeedback || !self.options.activeFeedback.questionId) {
            self.options.cancelFeedback();
            return;
          }

          if (self.options.activeFeedback.rubricId) {
            self.options.feedbackDirectory[self.options.activeFeedback.questionId][self.options.activeFeedback.rubricId] = self.options.feedbackModel;
            self.options.cancelFeedback();
            return;
          }
          self.options.feedbackDirectory[self.options.activeFeedback.questionId] = self.options.feedbackModel;
          self.options.cancelFeedback();
        },
        parse: function() {
          self.options.grades = {};
          self.options.list = [];
          if (!self.score || !self.score.graded_responses || !self.score.assessment_when_scored || !self.score.assessment_when_scored.questions || !self.score.assessment_when_scored.questions.length) {
            return;
          }


          self.score.assessment_when_scored.questions.forEach(function(question) {
            self.options.settings[question.id] = AssessmentLib.helpers.getQuestionOptions(question);
            if (question && question.id && self.score.graded_responses[question.id] && self.score.graded_responses[question.id].awaiting_manual_grade) {
              var item = {
                questionId: question.id,
                question: question.question,
                format: question.format,
                value: AssessmentLib.helpers.getQuestionValue(question),
                userResponse: self.score.graded_responses[question.id].user_answer
              };

              if (question.rubric_grading) {
                if (!question.rubric_options || !question.rubric_options.length) {
                  // Send info to slack
                  return;
                }
                item.rubric_grading = true;
                item.rubric_options = question.rubric_options;
                self.options.grades[question.id] = {};
              }

              self.options.list.push(item);

            }
          });
        },
        allowSubmit: function(item) {
          if (!self.options.grades[item.questionId] && self.options.grades[item.questionId] !== 0) {
            return false;
          }
          if (item.rubric_grading && item.rubric_options && item.rubric_options.length) {
            var graded = self.options.grades[item.questionId];
            for (var i = 0; i < item.rubric_options.length; i++) {
              var rubric = item.rubric_options[i];
              if (!rubric || !rubric.id || (!graded[rubric.id] && graded[rubric.id] !== 0)) {
                return false;
              }
            }
          }
          return true;
        }
      };

      self.comms = {
        loading: false,
        submit: function(item) {
          if (!item || !item.questionId) {
            return;
          }

          if (!item.rubric_grading) {
            if ((!self.options.grades[item.questionId] && self.options.grades[item.questionId] !== 0) || self.options.grades[item.questionId] < 0) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['gradeScore.include_numeric_value']});
              return;
            }

            if (self.options.grades[item.questionId] > item.value) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['gradeScore.exceeds_question_max']});
              return;
            }
          }

          if (item.rubric_grading) {
            if (!item.questionId || !self.options.grades[item.questionId]) {
              return;
            }
            var grades = self.options.grades[item.questionId];
            if (!item.rubric_options || !item.rubric_options.length) {
              // error to slack
              return;
            }
            for (var i = 0; i < item.rubric_options.length; i++) {
              var rubric = item.rubric_options[i];
              if (!rubric || !rubric.points || !rubric.id) {
                continue;
              }
              if ((!grades[rubric.id] && grades[rubric.id] !== 0) || grades[rubric.id] < 0) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['gradeScore.include_numeric_value_all']});
                return;
              }
              if (grades[rubric.id] > rubric.points) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['gradeScore.one_exceeds_max']});
                return;
              }
            }
          }
          var submitBody = {
            question_id: item.questionId,
            question_grade: self.options.grades[item.questionId],
            grader_id: self.user._id
          };

          if (self.options.feedbackDirectory[item.questionId]) {
            submitBody.feedback = self.options.feedbackDirectory[item.questionId];
          }
          self.comms.loading = true;

          UserAssessments.manualScore({
            subname: self.userAssessment._id,
            subsubname: self.score._id
          }, submitBody).$promise
          .then(function(results) {
            if (results.score) {
              self.score = results.score;
              self.options.parse();
            }
            self.comms.loading = false;
          }).catch(function(error) {
            console.log('error: ', error);
            self.comms.loading = false;
          });
        },
        back: function(completed) {
          $scope.goBack({completed: completed});
        }
      };

      self.status = {
        videoAssessment: false,
        fileAssessment: false,
        inContent: false,
        description: null,
        contentLink: null,
        parse: function(assessment, userAssessment) {
          self.status.description = assessment && assessment.description || null;
          if (!userAssessment || !userAssessment.content || !userAssessment.content_type) {
            self.status.inContent = false;
            self.status.contentLink = null;
            return;
          }
          self.status.inContent = true;

          if (assessment.content_type && assessment.content) {
            if (assessment.content_type === 'track') {
              self.status.contentLink = '/view/tracks/' + assessment.content + '/assessments/' + assessment._id;
            } else if (contentOptions[assessment.content_type]) {
              self.status.contentLink = '/view/' + contentOptions[assessment.content_type] + '/' + assessment.content + '?assessment=true';
            } else {
              self.status.inContent = false;
              self.status.contentLink = null;
            }
          }
        }
      };

      self.rubric = {
        getScoredValue: function(qid, rid) {
          if (!qid || !rid) {
            return '--';
          }
          var value = self.options.grades[qid] && self.options.grades[qid][rid];
          if (!value && value !== 0) {
            return '--'
          }

          return Math.round(parseFloat(value) * 10) / 10;
        },
        totalScoredValue: function(qid) {
          if (!qid) {
            return '--';
          }
          var value = 0;
          var foundValue = false;
          for (var key in self.options.grades[qid]){
            if (self.options.grades[qid][key]) {
              foundValue = true;
              value += self.options.grades[qid][key];
            }
          }
          if (!foundValue || (!value && value !== 0)) {
            return '--';
          }

          return Math.round(parseFloat(value) * 10) / 10;
        },
        totalScoredPercent: function(qid, value) {
          var score = self.rubric.totalScoredValue(qid);
          if (!score || score < 0) {
            return 0;
          }
          if (score >= value) {
            return 100;
          }
          return Math.round(score/value * 100);
        }
      };

      self.initialize = function() {
        self.score = null;
        self.userAssessment = null;
        self.comms.loading = true;
        $q.all([
          AssessmentScores.get({
            subresource: $scope.scoreId,
            fields: 'assessment_when_scored,graded_responses'
          }).$promise,
          UserAssessments.find({scores: $scope.scoreId, fields: '_id,scores,content,content_type'}).$promise
        ]).then(function(results) {
          self.score = results[0];
          self.userAssessment = results[1] && results[1][0];
          self.status.videoAssessment = self.score.assessment_when_scored.video_assessment ? true : false;
          self.status.fileAssessment = self.score.assessment_when_scored.file_assessment ? true : false;
          self.status.parse(self.score.assessment_when_scored, self.userAssessment);
          if (!self.userAssessment) {
            Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['gradeScore.score_no_longer_associated']});
            // Log something to slack
            return;
          }
          self.options.parse();
          self.comms.loading = false;
        }).catch(function(error) {
          self.comms.loading = false;
          console.log('error: ', error);
        });
      };

      $scope.$watch('scoreId', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.initialize();
        }
      });

      $translate([
        'gradeScore.include_numeric_value',
        'gradeScore.exceeds_question_max',
        'gradeScore.include_numeric_value_all',
        'gradeScore.one_exceeds_max',
        'gradeScore.score_no_longer_associated'
      ]).then(function (translations) {
        self.translations = translations;
        if ($scope.scoreId) {
          self.initialize();
        }
      });

    }],
    controllerAs: 'grade'
  };
}]);